import React, { ReactNode } from 'react';
import './WebsiteDesignProcess.scss';

import { motion } from 'framer-motion';

import { homePage } from '../../../editable-stuff/config';
import GradientButton from '../../../Library/GradientButton/GradientButton';

export default function WebsiteDesignProcess() {
  return (
    <section id='hover-boxes' className='p-150'>
      <div className='wave-top'>
        <svg
          fill='#ffffff'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-12 col-lg-3'>
            <motion.h2
              className='gradient mb-4'
              initial={{ x: '-100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 1 }}
            >
              {homePage?.websiteDesignProcess?.gradient_title}
            </motion.h2>
            <motion.div
              className='content'
              initial={{ x: '-100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <p>{homePage?.websiteDesignProcess?.subTitle}</p>
            </motion.div>
            <GradientButton
              text={homePage?.websiteDesignProcess?.button.text}
              link={homePage?.websiteDesignProcess?.button.link}
              svg={homePage?.websiteDesignProcess?.button.svg}
            />
          </div>
          <div className='col-12 col-lg-8 row'>
            {homePage?.websiteDesignProcess.designProcess.map((step, index) => (
              <PrecessStep
                title={step.title}
                content={step.content}
                svg={step.svg}
                stepNo={index + 1}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

interface PrecessStepProps {
  stepNo: number;
  title: string;
  content: string;
  svg: ReactNode;
}

const PrecessStep = ({ stepNo, title, content, svg }: PrecessStepProps) => {
  return (
    <div className='col-12 col-sm-6 col-lg-4'>
      <motion.div
        className='single'
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1.25 }}
      >
        <div className='inner'>
          {svg}
          <h4>
            {stepNo} {title}
          </h4>
          <div className='content'>
            <p>{content}</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
